import {
  VirtualTableColumnDef as ColumnDef,
} from 'core/components/VirtualTable/types';
import {
  VisitNoteServiceCode,
} from 'views/EMR/components/ServiceLookup/type';

const editableMeta = {
  editable: {
    props: { inputProps: { maxLength: 2 } },
    alwaysEditable: true,
  },
};

export default {
  id: 'pos',
  accessorFn: (row: VisitNoteServiceCode) => row?.serviceCodeDetails?.pos,
  columnTitle: 'POS',
  meta: editableMeta,
  size: 64,
  minSize: 64,
} as ColumnDef<VisitNoteServiceCode>;
